import * as _cmFTH from './_cmFTH';
import { useNgnz } from './_csNgn';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _hm from './_hm';
import * as _ht from './_ht';

export const chkPmn = (ftnNbr: _ht.n) => {
  const _gUserz = _gv.useUserz();
  if ( ftnNbr == 2000 ) {
    if (
      _gUserz.crt?._40rz?.[String(2210)] ||
      _gUserz.crt?._40rz?.[String(2310)] ||
      _gUserz.crt?._40rz?.[String(2410)] ||
      _gUserz.crt?._40rz?.[String(2510)] ||
      _gUserz.crt?._40rz?.[String(2610)] ||
      _gUserz.crt?._40rz?.[String(2710)] ||
      _gUserz.crt?._40rz?.[String(2810)] ||
      _gUserz.crt?._40rz?.[String(2910)]
    ) return true;
    return false;
  }
  else {
    if ( ftnNbr > 1000 ) {
      if (_gUserz.crt?._40rz?.[String(ftnNbr)]) return true;
      return false;
    }
  }
};

export const Map = (pz: {
  i: _ht.n, // 緯度
  k: _ht.n, // 経度
}) => {
  return (
    _cr.c('iframe', {
      src: `https://maps.google.com/maps?output=embed&q=${pz.i ?? 35.680959106959},${pz.k ?? 139.76730676352}&t=m&hl=ja&z=15`,
      width: '100%',
      height: '100%',
      frameBorder: '0',
    })
  );
}

export const cvtLcnAsync = async ( // cvt address to location
  ars: _ht.s,
) => {
  const _url = 'https://msearch.gsi.go.jp/address-search/AddressSearch?q=' + encodeURIComponent(ars);
  const _res = await fetch(_url, {
    method: 'GET'
  });
  const _dz = _hm.get1(JSON.parse(await _res.text()));
  //_hm.l(`icm 50: ${_hm.s(_dz)}`);
  const _ls = _dz?.geometry.coordinates;
  return { k: _ls[0], i: _ls[1] };
};

export const lot = (sNgnz: _ht.dz) => {
//  const _sNgnz = useNgnz();
  const _gUserz = _gv.useUserz();
  _gUserz.saveAsync({
    _20rz: {},
    _30rz: {},
    _10rz: {},
  })
  if (sNgnz?.getPageName() != 'icvLgnM10Rz') {
    sNgnz?.setPageName('icvLgnM10Rz');
  }
};
